// Module
var code = "<li id class=\"floorplan-level hidden\"> <img src=\"#\" class=\"floorplan-level-img\"/> <ul class=\"floorplan-points\"></ul> </li>";
// Exports
module.exports = code;